import { render, staticRenderFns } from "./SimulationPractice.vue?vue&type=template&id=764f5c9c&scoped=true&"
import script from "./SimulationPractice.vue?vue&type=script&lang=js&"
export * from "./SimulationPractice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764f5c9c",
  null
  
)

export default component.exports